import { EColors } from "common/styles";
import styled from "styled-components";

export const StyledSpan = styled.span<{
  bgColor:string
}>`
  position: relative;
  &:after {
    position: absolute;
    display: block;
    content: "";
    width: 100%;
    height: 3px;
    background: ${({ bgColor }) => bgColor};
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;